<!-- Add Comment -->
<div *ngIf="!isEditMode && !comment" class="row mt-2">
    <div class="col-12 text-end float-sm-end">
    <button type="button" class="btn btn-secondary add-button" (click)="addComment()"><i class="fas fa-plus"></i> Add
        Comment</button>
    </div>
</div>
<!-- Display Comment -->
<paetep-display-comment *ngIf="!isEditMode && comment"
    [comment]="comment"
    [observationType]="observationType" 
    [ngStyle]="getHeaderStyles()">
    <!-- Comment Actions -->
    <ng-template [ngIf]="!isReadOnly && !comment.historic && comment.userId==evalUser?.UserID">
        <button *paetepNested="true;tag:CommentTags.Comment" type="button" (click)="openComment(comment)" ngbTooltip="Edit comment"
            class="btn btn-sm btn-link me-3 edit-button" aria-label="Edit comment"><i class="far fa-edit"></i></button>
        <button *paetepNested="comment.commentState == CommentState.DRAFT;tag:CommentTags.Comment" type="button"
            ngbTooltip="Publish comment"
            (click)="publishComment(comment)" class="btn btn-sm btn-link me-3 publish-button" aria-label="Publish comment"><i
            class="far fa-check-square"></i></button>
        <button *paetepNested="comment.commentState == CommentState.DRAFT;tag:CommentTags.Comment"
            type="button"
            ngbTooltip="Delete comment"
            (click)="deleteComment(comment)" class="btn btn-sm btn-link delete-button" aria-label="Delete comment"><i
            class="far fa-trash-alt"></i></button>
    </ng-template>

    <!-- Attachment Actions -->
    <ng-template [paetepNested]="true" [paetepNestedTag]="CommentTags.Attachment" let-f>
        <paetep-attachment-button
            [attachment]="f" 
            [shouldDisplayDate]="true"
            [canDeleteAttachment]="!isReadOnly && !comment.historic"
            (onAttachmentDeleted)="onAttachmentDeleted($event)">
        </paetep-attachment-button>
    </ng-template>
</paetep-display-comment>

<!-- Edit Comment -->
<app-observation-comment-form *ngIf="isEditMode"
    [observationSummary]="observationSummary"
    [comment]="comment"
    (commentChange)="setComment($event)"
    [observationType]="observationType"
    [observationId]="observationSummary?.observationId"
    [defaultLookupValue]="comment?.lookupValue ?? defaultLookupValue"
    [hideLookup]="hideFilter"
    [attachmentLabel]="attachmentLabel"
    (onClose)="onClose()"
    [commentFiles]="comment?.attachments"
>
</app-observation-comment-form>

